import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        };

        this.getData = this.getData.bind(this);
    }

    static propTypes = {
        onSubmit: PropTypes.func,        
        nav: PropTypes.any
    }

    getData() {
        const { descripcion, asunto, cuerpo } = this.state;
        return {
            descripcion,
            asunto,
            cuerpo
        };
    }

    resetForm() {
        this.setState({
            isOpen: false,
            descripcion: '',
            asunto: '',
            cuerpo: ''
        });
        if (this.props.onClose) this.props.onClose();
    }

    setSelects(data) {
        this.setState({
            descripcion: data.descripcion,
            asunto: data.asunto,
            cuerpo: data.cuerpo
        });
    }

    onCuerpoChange = html => this.setState({ cuerpo: html });

    render() {
        return (
            <span>
            <ParadigmaModal
                getUrl={api.email.plantillas.edit}
                onPreSubmit={this.getData}
                postUrl={api.email.plantillas.edit}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Plantilla de Mail ha sido editada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}                
                title={"Editar Plantilla de Mail"}
                buttonTitle={"Editar"}
                className={"ui-modal-dialog ui-modal-editor"}
                buttonIcon={"fa fa-pencil fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                backdrop={false}
                cancelButtonLabel="Cancelar"
            >
                <div className="ui-form">
                    <PlantillaFormSections
                        descripcion={this.state.descripcion}
                        asunto={this.state.asunto}
                        cuerpo={this.state.cuerpo}
                        onDescripcionChange={e => this.setState({ descripcion: e.target.value })}
                        onAsuntoChange={e => this.setState({ asunto: e.target.value })}
                        onCuerpoChange={this.onCuerpoChange}
                    />
                </div>
            </ParadigmaModal>
            </span>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Config/Plantillas/Edit.js